import { lazyLoad } from 'utils/loadable';

export const ContactListPage = lazyLoad(
  () => import('./index'),
  module => module.ContactListPage,
);
